export const PRIVACY_LIMITED = 0;
export const PRIVACY_PRIVATE = 1;
export const PRIVACY_PUBLIC = 2;
export const PRIVACY_DELETED = 99;
export var INFRACTION_TYPES;
(function (INFRACTION_TYPES) {
    INFRACTION_TYPES["MUTE"] = "mute";
    INFRACTION_TYPES["BAN"] = "ban";
    INFRACTION_TYPES["WARNING"] = "warning";
    INFRACTION_TYPES["NOTE"] = "note";
    INFRACTION_TYPES["CODE_REDEEM_LOCK"] = "codeRedeemLock";
    INFRACTION_TYPES["NAME_SUBMISSION_LOCK"] = "nameSubmissionLock";
})(INFRACTION_TYPES || (INFRACTION_TYPES = {}));
export const INFRACTION_DISPLAY_NAMES = {
    [INFRACTION_TYPES.MUTE]: 'Mute',
    [INFRACTION_TYPES.BAN]: 'Ban',
    [INFRACTION_TYPES.WARNING]: 'Warning',
    [INFRACTION_TYPES.NOTE]: 'Note',
    [INFRACTION_TYPES.CODE_REDEEM_LOCK]: 'Code Redeem Lock',
    [INFRACTION_TYPES.NAME_SUBMISSION_LOCK]: 'Name Submission Lock',
};
export const INFRACTION_REASON_TYPES = [
    INFRACTION_TYPES.MUTE,
    INFRACTION_TYPES.BAN,
    INFRACTION_TYPES.WARNING,
    INFRACTION_TYPES.CODE_REDEEM_LOCK,
    INFRACTION_TYPES.NAME_SUBMISSION_LOCK,
];
export const INFRACTION_DURATION_TYPES = [
    INFRACTION_TYPES.MUTE,
    INFRACTION_TYPES.BAN,
    INFRACTION_TYPES.CODE_REDEEM_LOCK,
    INFRACTION_TYPES.NAME_SUBMISSION_LOCK,
];
export const INFRACTION_SUPPORTING_EVIDENCE_TYPES = [
    INFRACTION_TYPES.MUTE,
    INFRACTION_TYPES.BAN,
    INFRACTION_TYPES.WARNING,
    INFRACTION_TYPES.CODE_REDEEM_LOCK,
    INFRACTION_TYPES.NAME_SUBMISSION_LOCK,
];
export const INFRACTION_NOTES_TYPES = [
    INFRACTION_TYPES.MUTE,
    INFRACTION_TYPES.BAN,
    INFRACTION_TYPES.WARNING,
    INFRACTION_TYPES.NOTE,
    INFRACTION_TYPES.CODE_REDEEM_LOCK,
    INFRACTION_TYPES.NAME_SUBMISSION_LOCK
];
